import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"
import { burnChartConfig, changeOrdersChartConfig, healthChartConfig } from "../lib/portfolio_trend_chart_configs"

// Ask AI dashboard chat — standalone trend chart cards
// (trend_budget_burn / trend_change_orders / trend_project_health).
// Renders ONE of the portfolio trend charts using the exact same
// Chart.js configs as the collapsible Trends strip, so the cards and
// the strip look identical.
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    kind: String,
    series: Object
  }

  connect() {
    if (!this.hasCanvasTarget) return
    const s = this.seriesValue || {}
    const config =
      this.kindValue === "change_orders" ? changeOrdersChartConfig(s) :
      this.kindValue === "health" ? healthChartConfig(s) :
      burnChartConfig(s)
    this._chart = new Chart(this.canvasTarget, config)
  }

  disconnect() {
    if (this._chart) this._chart.destroy()
    this._chart = null
  }
}
